import { useState } from "react";
import { cn } from "@/lib/utils";

/** A person's picture, or their initials on the brand colour when there is none (or it fails to load). */
export default function UserAvatar({ src, name, className, rounded = "full" }: { src?: string | null; name?: string; className?: string; rounded?: "full" | "xl" }) {
  const [failed, setFailed] = useState<string | null>(null);
  const initials = (name ?? "").split(/\s+/).filter(Boolean).slice(0, 2).map((w) => w[0]).join("").toUpperCase() || "?";
  const shape = rounded === "full" ? "rounded-full" : "rounded-xl";
  if (src && failed !== src) {
    return <img src={src} alt={name ?? ""} onError={() => setFailed(src)} className={cn("shrink-0 object-cover", shape, className)} />;
  }
  return (
    <span className={cn("inline-flex shrink-0 items-center justify-center bg-primary text-xs font-semibold text-white", shape, className)} aria-label={name}>
      {initials}
    </span>
  );
}
